import { render, staticRenderFns } from "./chaireman_message.vue?vue&type=template&id=67b00df5&scoped=true&"
import script from "./chaireman_message.vue?vue&type=script&lang=js&"
export * from "./chaireman_message.vue?vue&type=script&lang=js&"
import style0 from "./chaireman_message.vue?vue&type=style&index=0&id=67b00df5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b00df5",
  null
  
)

export default component.exports